var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginTransformersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M21.5 6.829v11.173a1.93 1.93 0 0 1-.587 1.413 1.926 1.926 0 0 1-1.413.587H7.3l1.6 1.6-1.4 1.4-4-4 4-4 1.4 1.4-1.6 1.6h12.2V8.828l2-2zM16.5 1l4 4-4 4-1.4-1.4L16.7 6H4.5l-.001 9.175-2 2L2.5 6c0-.489.155-.915.464-1.279l.123-.133A1.926 1.926 0 0 1 4.5 4h12.2l-1.6-1.6L16.5 1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "m13.87 6-1.598 1.6 4.228 4.228 3-3V18h-9.37l1.598-1.598L7.5 12.174l-3 3V6z"
}))));
export default SvgPluginTransformersIcon;